import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import View from "./forgetPassword";
import { forgetPassword, confirmChangePassword } from "../../APIs";
import { getUrlVars, errorHandler } from "../../utils";
import { withMultiLanguagesConsumer } from "../../contexts/messages";
import { getOAuth2SearchString } from '../../utils';
import { isUSezpayRequest } from '../../utils/domainDetection';
class ForgetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            username: "",
            newPassword: "",
            confirmPassword: "",
            loading: false,
            phoneOrEmail: 'email',
            verifySent: false
        }
        this.verification = "";
        this.fromDomain = this.props.match.params.domain;
        this.fromMerchantId = this.props.match.params.merchantId;
        this.setInputField = this.setInputField.bind(this);
        this.loadingToggler = this.loadingToggler.bind(this);
        this.confirmChange = this.confirmChange.bind(this);
        this.selectPhoneOrEmail = this.selectPhoneOrEmail.bind(this);
    }
    selectPhoneOrEmail(option) {
        this.setState({
            phoneOrEmail: option,
            username: ""
        })
    }
    setInputField = field => {
        if (field == 'username') {
            return event => {
                if (this.state.phoneOrEmail == "phone") {
                    let phone = "";
                    for (let i = 0; i < event.target.value.length; i++) {
                        if (event.target.value.charAt(i) >= '0' && event.target.value.charAt(i) <= '9') {
                            phone += event.target.value.charAt(i);
                        }
                    }
                    this.setState({ username: phone.substring(0, 10) });
                } else if (this.state.phoneOrEmail == "email") {
                    this.setState({ username: event.target.value.toLowerCase() })
                } else {
                    this.setState({ [field]: event.target.value });
                }
            }
        } else {
            return event => {
                this.setState({ [field]: event.target.value });
            }
        }        
    };

    loadingToggler() {
        this.setState({
            loading: !this.state.loading
        })
    }

    confirmChange() {
        const { PWD_NOT_MATCH, PWD_RESET_SUCCESS } = this.props.messagePool;
        if (this.state.newPassword != this.state.confirmPassword) {
            alert(PWD_NOT_MATCH);
            return;
        }
        this.loadingToggler();
        let username = this.state.username;
        if (this.state.phoneOrEmail == "phone") {
            username = "+1" + username;
        }
        let verification = this.state.verification;
        if (this.verification) {
            verification = this.verification;
        }
        confirmChangePassword(username, this.state.newPassword, verification)
        .then(res => {
            const redirect_uri = getUrlVars()["redirect_uri"];
            if (redirect_uri) {
                alert(PWD_RESET_SUCCESS);
                const oauth2SearchStr = getOAuth2SearchString()
                const backUrl = "/login?" + oauth2SearchStr;
                window.location.href = backUrl
            } else {
                alert(res.data.Success);
                this.setState({
                    loading: false,
                    step: 2
                })
            }
        })
        .catch(err => {
            this.loadingToggler();
            errorHandler(err);
        })
    }

    componentWillMount() {
        const verification = getUrlVars()["verification"];
        if (verification) {
            this.setState({
                step: 1,
            })
            this.verification = verification;
        }
    }

    render() {
        const isUSezpay = isUSezpayRequest();
        return (
            <View {...this.state}
                setInputField={this.setInputField}
                confirmChange={this.confirmChange}
                selectPhoneOrEmail={this.selectPhoneOrEmail}
                isUSezpay={isUSezpay} />
        );
    }
}

function mapStateToProps(state){
    return{
        
    }
}

export default withMultiLanguagesConsumer(withRouter(connect(mapStateToProps, {
    
})(ForgetPassword)));